import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ProcessoCliente } from '../../comum/modelos/processo-cliente';

@Component({
    selector: 'app-modal-pontos-fisicos-rotina',
    templateUrl: './modal-pontos-fisicos-rotina.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./modal-pontos-fisicos-rotina.component.css']
})
export class ModalPontosFisicosRotinaComponent implements OnInit {

    @Input() processoCliente: ProcessoCliente;

    constructor(private modalService: NgbModal) {
    }

    cadastrar(content) {
        const ngbModalOptions: NgbModalOptions = {
            backdrop: 'static',
            keyboard: false,
            windowClass: 'modalPontosFisicosRotina',
            size: 'lg'
        };
        this.modalService.open(content, ngbModalOptions).result.then((result) => {
        }, (reason) => {
        });
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/rotina/modal-pontos-fisicos-rotina/modal-pontos-fisicos-rotina.component.ts